import * as Yup from 'yup'
export const SchoolPaymentsSchema = Yup.object().shape({
  otherBillPaymentId: Yup.number().required(' Institution Name is required'),
  serviceNumber: Yup.string().required('Student ID is required'),
  //beneName: Yup.string().required('Student Name is required'),
  amount: Yup.string().required('Amount is required'),
  remarks: Yup.string().min(4, 'Minimum 4 Characters').required('Remarks is required'),
})

export const OtherPaymentsSchema = Yup.object().shape({
  otherBillPaymentId: Yup.number().required(' Utility is required'),
  serviceNumber: Yup.string()
    .required('Customer ID is required'),
  amount: Yup.string().required('Amount is required'),
  remarks: Yup.string().min(4, 'Minimum 4 Characters').required('Remarks is required'),
})

export const SetTargetsSchema = Yup.object().shape({
  rdAccDesc: Yup.string().required('Purpose is required'),
  srcAccNo: Yup.string().required('Account No. is required'),
})
